import { useCallback, useState } from 'react';

// Interactive elements inside a row (links, checkboxes, buttons) keep their own behaviour instead of toggling it.
const INTERACTIVE_SELECTOR = 'a, button, input, label';

export function useExpandedCaseRows() {
  const [expandedNumbers, setExpandedNumbers] = useState<Array<string>>([]);

  const isExpanded = useCallback((caseNumber: string) => expandedNumbers.includes(caseNumber), [expandedNumbers]);

  const toggle = useCallback((caseNumber: string) => {
    setExpandedNumbers((current) =>
      current.includes(caseNumber) ? current.filter((number) => number !== caseNumber) : [...current, caseNumber],
    );
  }, []);

  const handleRowClick = useCallback(
    (event: React.MouseEvent, caseNumber: string) => {
      const { target } = event;
      if (target instanceof Element && target.closest(INTERACTIVE_SELECTOR)) {
        return;
      }
      toggle(caseNumber);
    },
    [toggle],
  );

  return { isExpanded, toggle, handleRowClick };
}
